import React, { useContext, useMemo } from "react";
import { LangContext } from "../../context/lang/LangContext";
import { Link } from "gatsby";
import { navigate } from "@reach/router";

interface Props {
  frontmatter: {
    date: string;
    title: string;
    slug_en: string;
    slug_es: string;
    lang: string;
  };
}

export const LangAdvice = ({ frontmatter }: Props) => {
  const { messages } = useContext(LangContext);

  React.useEffect(() => {
    const lang = messages.currentLanguage;
    const path = `/${lang}/for-developers`;
    if (lang === frontmatter.lang) return;

    switch (lang) {
      case "en":
        navigate(`${path}${frontmatter.slug_en}`);
        break;
      case "es":
        navigate(`${path}${frontmatter.slug_es}`);
        break;
      default:
        navigate(`${path}${frontmatter.slug_en}`);
        break;
    }
  }, [messages.currentLanguage, frontmatter.slug_en, frontmatter.slug_es]);

  const currentLangBlogSlug = useMemo(() => {
    const propiety = "slug_" + messages.currentLanguage;
    const slug = frontmatter[propiety as keyof typeof frontmatter];
    return slug;
  }, [messages.currentLanguage, frontmatter]);

  return (
    <>
      {frontmatter.lang !== messages.currentLanguage && (
        <div className="ForDevelopers__LangAdvice_container">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
              stroke="#7F9B28"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 7.5H8V11H8.5"
              stroke="#7F9B28"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.875 5.75C8.15114 5.75 8.375 5.52614 8.375 5.25C8.375 4.97386 8.15114 4.75 7.875 4.75C7.59886 4.75 7.375 4.97386 7.375 5.25C7.375 5.52614 7.59886 5.75 7.875 5.75Z"
              fill="#7F9B28"
            />
          </svg>
          <span>{messages.forDevelopers.langAdvice1}</span>{" "}
          <Link
            to={`/${messages.currentLanguage}/for-developers${
              currentLangBlogSlug ? currentLangBlogSlug : "/"
            }`}
          >
            {messages.forDevelopers.langAdvice2}
          </Link>
        </div>
      )}
    </>
  );
};
